import { Box } from "@mui/material"
import { MenuAccount } from "../../components/Account/Menu"

export const HomeAccountPage = () => {
    return(
        <Box>
            <MenuAccount />
        </Box>
    )
}